import ReactDOM from "react-dom";
import { ShortsPage } from "../components/shorts/ShortsPage";
import { initializeI18n } from "../localization/i18n";

window.renderShorts = (elementId, props) => {
  const container = document.getElementById(elementId);
  if (!container) return;

  initializeI18n()
    .then(() => {
      ReactDOM.render(<ShortsPage props={props} />, container);
    })
    .catch(() => {});
};
